const STATS = [
  { kpi: "8.3%", label: "of e-commerce customers have 10K+ followers" },
  { kpi: "6.4×", label: "higher reply rate vs cold creator outreach" },
  { kpi: "42M+", label: "creator profiles matched & verified" },
  { kpi: "<2 min", label: "average install-to-first-match time" },
];

export default function Metrics() {
  return (
    <section
      data-testid="metrics-section"
      className="relative py-24 md:py-28 border-y border-white/5 bg-[#0B0B0D]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5">
          {STATS.map((s) => (
            <div
              key={s.label}
              data-testid={`metric-${s.kpi}`}
              className="bg-[#0B0B0D] p-8 md:p-10"
            >
              <div className="font-display uppercase text-5xl md:text-6xl text-[#D4FF00]">
                {s.kpi}
              </div>
              <p className="mt-4 text-xs tracking-[0.14em] uppercase text-[#A1A1AA] leading-relaxed max-w-[200px]">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
